import React from "react";
import { IContract, ICustomer } from "dataModels/contract";
import { Row, Col } from "react-grid-system";
import moment from "moment";
import { DATE_FORMAT, DsLayout, FormMode } from "shared/constants";
import { useTranslation } from "react-i18next";
import SimpleTable from "components/SimpleTable";
import { v4 as uuid } from "uuid";
//import _ from "lodash";
import ContractLimitsDisplay from "views/contractView/components/contractLimitsDisplay";
//import ContractSlotChart from "views/contractView/components//contractSlotChart";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { Output, Table } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
import ContractDataDisplay from "./contractDataDisplay";

interface INewContractFormProps {
    formMode: FormMode,
    customer: ICustomer,
    formData: IContract
}
const ContractFormReview: React.FC<INewContractFormProps> = (props): JSX.Element => {
    const { formMode, formData, customer } = props;
    const { t } = useTranslation(['contract']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const documentTableCols = (() => {
        //return ["Nome", "Data fine validità", ""]
        return t("contract.contractForm.sections.review.fileInfo.headers", { ns: 'contract', returnObjects: true }) as string[];
    })();

    const documentTableRows = (): JSX.Element[] => {
        return [<tr key={uuid()}>
            <td>{t('contract.contractForm.sections.review.fileInfo.docName')}</td>
            <td>{formData.documents[0].name}</td>
            <td>{parseDateForDS(moment.unix(formData.documents[0].expire!).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}</td>
        </tr>]
    }

        const getTableRows = (): ITableRow[] => {
                  let myRetArr: ITableRow[] = [];
                      let tempObj: ITableRow = {
                          tableCells: [
                              { 
                                  type: "text", 
                                  text: t('contract.contractForm.sections.review.fileInfo.docName')
                              },
                              { 
                                  type: "text", 
                                  text: formData.documents[0].name,
                              },
                              { 
                                  type: "text", 
                                  text: parseDateForDS(moment.unix(formData.documents[0].expire!).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1),
                              }
                          ]
                      
                  }
                  myRetArr.push(tempObj);
                  return myRetArr;
          };
const myTableConfig: ITableConfig = {
              ...getDSTableSharedElements(150),
              tableHeader: {
                  
                  tableCellsHeader: [
                    getTableCellsHeaderSimple(t("contract.contractForm.sections.review.fileInfo.headers.0", { ns: 'contract' }) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("contract.contractForm.sections.review.fileInfo.headers.1", { ns: 'contract' }) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t("contract.contractForm.sections.review.fileInfo.headers.2", { ns: 'contract' }) as string,"col3","33%","left"),
                  ]
              },
              tableRows: getTableRows()
          };

    return (
        <>
            {formMode === FormMode.NEW && <Row style={{ marginBottom: "12px" }}>
                <Col>
                    <div className="box">
                        <div className="boxTitle">
                            {t('contract.contractForm.sections.review.companyInfo.title')}
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle= {t('contract.contractForm.sections.review.companyInfo.headers.0')}
                                    outputText={formData.customerName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    {t('contract.contractForm.sections.review.companyInfo.headers.0')}
                                </p>
                                <p className="boxFieldData">{formData.customerName}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle= {t('contract.contractForm.sections.review.companyInfo.headers.1')}
                                    outputText={formData.customerVat}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    {t('contract.contractForm.sections.review.companyInfo.headers.1')}
                                </p>
                                <p className="boxFieldData">{formData.customerVat}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle= {t('contract.contractForm.sections.review.companyInfo.headers.2')}
                                    outputText={customer.businessAddress+" "+customer.businessStreetNumber+" "+customer.businessCity+" "+customer.businessState}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    {t('contract.contractForm.sections.review.companyInfo.headers.2')}
                                </p>
                                <p className="boxFieldData">{customer.businessAddress} {customer.businessStreetNumber} {customer.businessCity} {customer.businessState}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('contract.contractForm.sections.review.companyInfo.headers.3')}
                                    outputText={customer.businessCity+" - "+customer.businessState}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    {t('contract.contractForm.sections.review.companyInfo.headers.3')}
                                </p>
                                <p className="boxFieldData">{customer.businessCity} - {customer.businessState}</p>*/}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>}

            <Row>
                <Col>
                    <div className="box">
                        <div className="boxTitle">
                            {t('contract.contractForm.sections.review.contractInfo.title')}
                        </div>
                        {/*<div className="boxContent">

                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.0')}
                                    outputText={formData.code}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.3')}
                                    outputText={formData.slot.toString()}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.6')}
                                    outputText={formData.rateLoading.toString() + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.10')}
                                    outputText={formData.rateSemiTrailerApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.14')}
                                    outputText={formData.rateIsoContainerAndDriverApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                
                            </div>

                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.1')}
                                    outputText={parseDateForDS(moment.unix(formData.startDate).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.4')}
                                    outputText={formData.topPercentage.toString()}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.7')}
                                    outputText={formData.rateLoadingBio + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.11')}
                                    outputText={formData.rateDriverApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.15')}
                                    outputText={formData.rateTruckTractorApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.1')}
                                    style={{marginBottom:'16px'}}
                                ></Output>

                                
                            </div>

                            <div className="boxContentColumn">

                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.2')}
                                    outputText={parseDateForDS(moment.unix(formData.endDate).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.8')}
                                    outputText={formData.rateCoolDown + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.12')}
                                    outputText={formData.rateSemiTrailerAndDriverApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.16')}
                                    outputText={formData.rateContainerPlatformApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.1')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                
                            </div>

                            <div className="boxContentColumn">
                                
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.9')}
                                    outputText={formData.rateGasUp + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.13')}
                                    outputText={formData.rateIsoContainerApproval + " "+t('contract.contractForm.sections.dataInput.fieldDesc.0')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                <Output
                                    outputTitle={t('contract.contractForm.sections.dataInput.fields.17')}
                                    outputText={formData.fineFailureTake + " "+t('contract.contractForm.sections.dataInput.fieldDesc.2')}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                
                            </div>

                        </div>*/}
                        <ContractDataDisplay contractData={formData}/>
                    </div>
                </Col>
            </Row>

            {formMode === FormMode.NEW &&
                <>
                    <p className="documentTableTitle--contract">
                        {t('contract.contractForm.sections.review.fileInfo.tableTitle')}
                    </p>

                    <div style={{ /*borderRadius: "12px",*/ background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-0, #FFF)", padding: "12px", marginTop: "12px" }}>
                        {/*<SimpleTable
                            columns={documentTableCols}
                            rows={documentTableRows()}
                        />*/}
                        {
                            <Table 
                            tableConfig={myTableConfig} 
                        />
                        }
                    </div>
                    <DsHorizontalDivider />
                </>
            }

            {/* Contract limits */}
            <div style={{marginTop:"48px"}}>
                <ContractLimitsDisplay contract={formData} />
            </div>

            {
                /* Chart */
                /*formMode === FormMode.EDIT &&
                <div style={{ padding: "12px" }}>
                    <p className="documentTableTitle--contract">
                        {t('contract.contractData.chart.title')}
                    </p>
                    <div style={{ borderRadius: "12px", background: "var(--Neutrali-0, #FFF)", marginTop: "24px" }}>
                        <ContractSlotChart
                            contract={formData} />
                    </div>
                </div>*/

            }

        </>

    )
}

export default ContractFormReview;